export default "__VITE_ASSET__DEmVwopz__"